import styled from 'styled-components';

export const ErrorMessage = styled.p`
	color: #ff4242;
	font-size: 10px;
	position: absolute;
	margin-top: 4px;
`;
